module.exports = __webpack_public_path__ + "img/fy.4dcfa42e.gif";